<template>
<v-container grid-list-xl fluid>
    <v-layout row wrap>
        <v-flex lg12>
            <v-card>
                <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                <v-data-table :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
                    <template v-slot:item="{ item }">
                        <tr :id="'r-' + item.ID">
                            <td>{{ item.TransactionCode}}</td>
                            <td v-if="!canSetStoreStaff">{{ item.StoreStaffName }}</td>
                            <td v-if="canSetStoreStaff">
                                <v-edit-dialog
                                :return-value.sync="item.StoreStaffID"
                                large
                                lazy
                                persistent
                                @save="saveItem(item)"
                                >
                                    <v-tooltip top absolute right offset-overflow max-width="250" color="light-green lighten-5 black--text">
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">{{ item.StoreStaffID | display_value(listStaffs) }}</span>
                                        </template>
                                        <span>{{ item.StoreStaffID | display_value(listStaffs) }}</span>
                                    </v-tooltip>
                                    <template v-slot:input>
                                        <v-select
                                        v-model="item.StoreStaffID"
                                        label="Nhân viên kho"
                                        :items="listStaffs" item-text="name" item-value="value"
                                        ></v-select>
                                    </template>
                                </v-edit-dialog>
                            </td>
                            <td>{{ item.KennelName}}</td>
                            <td>{{ item.UID }}</td>
                            <td>{{ (item.OrderType == 1 ? 'A' : 'KG') + item.OrderID}}</td>
                            <td>{{ item.Username}}</td>
                            <td v-bind:style="{ 'color': get_status_color(item.PaymentStatus, payment_status)}">{{ item.PaymentStatus | display_value(payment_status) }}</td>
                            <td v-bind:style="{ 'color': get_status_color(item.Status, package_status)}">{{ item.Status | display_value(package_status) }}</td>
                            <td>
                                <v-edit-dialog
                                :return-value.sync="item.StoreVNState"
                                large
                                lazy
                                persistent
                                @save="saveItem(item)"
                                >
                                    <v-tooltip top right max-width="250">
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">{{ item.StoreVNState | display_value(package_states) }}</span>
                                        </template>
                                        <span>{{ item.StoreVNState | display_value(package_states) }}</span>
                                    </v-tooltip>
                                    <template v-slot:input>
                                        <v-select
                                        v-model="item.StoreVNState"
                                        label="Tình trạng hàng"
                                        :items="package_states" item-text="name" item-value="value"
                                        ></v-select>
                                    </template>
                                </v-edit-dialog>
                            </td>
                            <td class="truncate">
                                <v-edit-dialog
                                :return-value.sync="item.StoreVNNote"
                                large
                                lazy
                                persistent
                                @save="saveItem(item)"
                                >
                                    <v-tooltip top right max-width="250">
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">{{ item.StoreVNNote }}</span>
                                        </template>
                                        <span>{{ item.StoreVNNote }}</span>
                                    </v-tooltip>
                                    <template v-slot:input>
                                        <v-textarea
                                        v-model="item.StoreVNNote"
                                        label="Ghi chú"
                                        autofocus
                                        ></v-textarea>
                                    </template>
                                </v-edit-dialog>
                            </td>
                            <td class="truncate">
                                <v-edit-dialog
                                :return-value.sync="item.ShippingInfo"
                                large
                                lazy
                                persistent
                                @save="saveItem(item)"
                                >
                                    <v-tooltip top right max-width="250">
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">{{ item.ShippingInfo }}</span>
                                        </template>
                                        <span>{{ item.ShippingInfo }}</span>
                                    </v-tooltip>
                                    <template v-slot:input>
                                        <v-textarea
                                        v-model="item.ShippingInfo"
                                        label="Thông tin nhận hàng"
                                        autofocus
                                        ></v-textarea>
                                    </template>
                                </v-edit-dialog>
                            </td>
                            <td class="truncate">
                                <v-edit-dialog
                                :return-value.sync="item.ShippingMethod"
                                large
                                lazy
                                persistent
                                @save="saveItem(item)"
                                >
                                    <v-tooltip top right max-width="250">
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">{{ item.ShippingMethod }}</span>
                                        </template>
                                        <span>{{ item.ShippingMethod }}</span>
                                    </v-tooltip>
                                    <template v-slot:input>
                                        <v-textarea
                                        v-model="item.ShippingMethod"
                                        label="Hình thức gửi"
                                        autofocus
                                        ></v-textarea>
                                    </template>
                                </v-edit-dialog>
                            </td>
                            <td class="text-center">
                                <v-tooltip top v-if="item.Status == 5 && !csRole && getRollbackState(item.StoreVNState)">
                                    <template v-slot:activator="{ on }">
                                        <v-icon v-on="on" medium class="mr-2" @click="deliverPackage(item.ID, package_status_enum.DA_VE_VN)">fa-undo</v-icon>
                                    </template>
                                    <span>Huỷ xuất kho</span>
                                </v-tooltip>
                                <v-tooltip top v-if="item.Status == 4 && !csRole && getExportState(item.StoreVNState)">
                                    <template v-slot:activator="{ on }">
                                        <v-icon v-on="on" medium class="mr-2" @click="deliverPackage(item.ID, package_status_enum.DA_XUAT_KHO)">fa-dolly-flatbed</v-icon>
                                    </template>
                                    <span>Xuất kho</span>
                                </v-tooltip>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-flex>
    </v-layout>
</v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import Filtering from "@/components/Filtering";
import _ from "lodash";

export default {
    components: {
        "hpo-filter": Filtering
    },
    data() {
        return {
            headers: [
                {
                    text: "Mã vận đơn",
                    value: "TransactionCode",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Nhân Viên kho",
                    value: "StoreStaffName",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Lưu kho",
                    value: "KennelName",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Mã KH",
                    value: "UID",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Mã đơn hàng",
                    value: "OrderID",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Khách hàng",
                    value: "Username",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Trạng thái công nợ",
                    value: "PaymentStatus",
                    filterable: true,
                    values: configs.PAYMENTORDER_STATUS_LIST,
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: "Trạng thái",
                    value: "Status",
                    filterable: true,
                    values: configs.PACKAGE_STATUS,
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: "Vận hành kho",
                    value: "StoreVNState",
                    filterable: true,
                    values: [],
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: "Ghi chú",
                    value: "StoreVNNote",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Thông tin nhận hàng",
                    value: "ShippingInfo",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Hình thức gửi",
                    value: "ShippingMethod",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Thao tác",
                    value: "",
                    align: "center",
                    sortable: false,
                    filterable: false
                }
            ],
            payment_status: configs.PAYMENTORDER_STATUS_LIST,
            package_status_enum: configs.PACKAGE_STATUS_ENUM,
            package_status: configs.PACKAGE_STATUS,
            pagination: { ...configs.PAGINATION, sortBy: ["ID"]},
            items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
            viewName: "deliverable_list",
            filterConditions: [],
            quickFilterConditions: [],
            requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        },
        package_states() {
            let header_item = _.find(this.headers, {value: "StoreVNState"});
            if(header_item) {
                header_item.values = this.configuration && this.configuration.PackageState ? JSON.parse(this.configuration.PackageState) : []
            }
        }
    },
    computed: {
        ...mapState({
            items: state => state.deliverable.all.data,
            total_rows: state => state.deliverable.all.total,
            loading: state => state.deliverable.loading,
            configuration: state => state.configuration.selected
        }),
        tableConfig() {
            return {
                pagination: this.pagination,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions
            }
        },
        csRole() {
            return ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.CustomerService) == configs.ROLE_TYPE.CustomerService);
        },
        canSetStoreStaff() {
            if ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.CustomerService) == configs.ROLE_TYPE.CustomerService) return true;
            return ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin);
        },
        storeRole() {
            return ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreVN) == configs.ROLE_TYPE.StoreVN);
        },
        listStaffs() {
            if (this.$store.state.commons && this.$store.state.commons.all_users) {
                return this.$store.state.commons.all_users.filter(u => (u.RoleType & configs.ROLE_TYPE.StoreVN) == configs.ROLE_TYPE.StoreVN && u.is_active == 1).map(u => {
                    return { name: u.Username, value: u.ID };
                })
            }
            return [];
        },
        package_states() {
            return this.configuration && this.configuration.PackageState ? JSON.parse(this.configuration.PackageState) : [];
        },
    },
    methods: {
        filter_data: function () {
            if (this.storeRole) {
                this.filterConditions.push({ column: 'StoreStaffID', condition: "in", value: [this.$store.state.authentication.user.userid] });
            }
            if (this.csRole) {
                this.filterConditions.push({ column: 'CustomerServiceID', condition: "in", value: [this.$store.state.authentication.user.userid] });
            }
            this.$store.dispatch("deliverable/getList", this.tableConfig);
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy
            let sortDesc = this.pagination.sortDesc
            this.pagination = configs.PAGINATION;
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        deliverPackage(id, status) {
            var param = {
                pagination: this.pagination,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions
            };
            this.$store.dispatch("deliverable/setDetail", {param: this.tableConfig, data: {
                'ID': id,
                'Status': status
            }});
        },
        get_status_color(val, enums) {
            return this.$options.filters.display_color(val, enums);
        },
        saveItem(item) {
            this.$store.dispatch("orderTransaction/setDetail", {'data': {'StoreStaffID': item.StoreStaffID, 'StoreVNState': item.StoreVNState, 'StoreVNNote': item.StoreVNNote, 'ShippingInfo': item.ShippingInfo, 'ShippingMethod': item.ShippingMethod}, 'id': item.ID});
        },
        getExportState(val) {
            let item = _.find(this.package_states, {value: val});
            return item ? item.export : 0;
        },
        getRollbackState(val) {
            let item = _.find(this.package_states, {value: val});
            return item ? item.rollback : 0;
        }
    },
    mounted() {
        this.$store.dispatch("configuration/getDetail", 1);
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_CREATE_DATA", this.createData);
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
            this.$store.dispatch("feeBuy/removeDetail", id);
            setTimeout(this.filter_data, 200);
        });
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_CREATE_DATA", this.createData);
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$off("CONFIRMED_REMOVE_DATA");
    }
};
</script>
